import { ReactNode, MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { AuroraHeatingElementMode } from '../enums'
import AuroraControl from './AuroraControl'

export interface AuroraHeatingElementRelayModeControlProps {
  label: ReactNode
  value: AuroraHeatingElementMode
  loading?: boolean
  disabled?: boolean
  onSubmit: (mode: AuroraHeatingElementMode) => Promise<void>
}

export default function AuroraHeatingElementRelayModeControl({
  label,
  value,
  loading = false,
  disabled = false,
  onSubmit
}: AuroraHeatingElementRelayModeControlProps) {
  const { t } = useTranslation('aurora')

  async function handleChange(_: MouseEvent<HTMLElement>, newValue: AuroraHeatingElementMode) {
    try {
      await onSubmit(newValue)
    } catch {
      // Ignore the error.
    }
  }

  return (
    <AuroraControl
      direction="column"
      label={label}
      loading={loading}
      disabled={disabled}
      control={
        <ToggleButtonGroup
          color="primary"
          value={value}
          sx={{ mt: 2 }}
          exclusive
          disabled={disabled}
          onChange={handleChange}
        >
          <ToggleButton value={AuroraHeatingElementMode.OFF}>{t('off')}</ToggleButton>
          <ToggleButton value={AuroraHeatingElementMode.LOCAL_AUTOMATION}>
            {t('localAutomation')}
          </ToggleButton>
          <ToggleButton value={AuroraHeatingElementMode.CLOUD_AUTOMATION}>
            {t('cloudAutomation')}
          </ToggleButton>
        </ToggleButtonGroup>
      }
    />
  )
}
